﻿export enum OnlineDebateLinkTypeEnum {
    Complaint = 1,
    SessionAgenda = 2
}